// extracted by mini-css-extract-plugin
export default {"modalBody":"VideoModal_modalBody__c8VUM"};